module.exports = {
      url: "https://app.robbiert.com/api" ,
      drift_id: "i532prgxgy29" ,
      sentry_dns: "https://5659a6f0794341fdb6c5d13ce6f72c02@o470428.ingest.sentry.io/4504982378905600" 
      };
